import React from 'react';
import { TitleHeader } from 'web-library';
import Notes from '../../modules/appeal/components/@candidate/Notes';

interface AppealImportantNotesProp {
  title: string;
}

const AppealImportantNotes = ({ title }: AppealImportantNotesProp) => (
  <>
    <TitleHeader title={title} />
    <Notes />
  </>
);
export default AppealImportantNotes;
